<template>
    <div class="main-chat-box" :style="styles ? styles.scrollBg : ''">
        <div class="history-log-chat">
            <div style="text-align: center;" v-if="displayLoadingChatlogs">
                <v-progress-circular
                        :size="20"
                        :width="2"
                        color="green"
                        indeterminate
                />
            </div>
            <div class="clearfix" v-for="msg in listMsg" :key="'msg_index_' + msg.id">
                <ChatTextBox
                        v-if="msg.type==='text' || msg.type==='payload'"
                        :isFirstMsg="msg.isFirstMsg"
                        :isLastMsg="msg.isLastMsg"
                        :isUserSend="msg.source==='user'"
                        :content="msg.content"
                        :msgId="msg.id"
                        :msgReact="msg.react_icon"
                />
                <ChatImageBox
                        v-if="msg.type==='image' || (msg.type==='zalo_list_template' && msg.content.cross_channel===true)"
                        :isFirstMsg="msg.isFirstMsg"
                        :isLastMsg="msg.isLastMsg"
                        :isUserSend="msg.source==='user'"
                        :content="msg.content"
                        :msgId="msg.id"
                        :msgReact="msg.react_icon"
                />
                <!-- <ChatDownloadBox
                  v-if="msg.type==='upload_file'"
                  :isFirstMsg="msg.isFirstMsg"
                  :isLastMsg="msg.isLastMsg"
                  :isUserSend="msg.source==='user'"
                  :content="msg.content"
                ></ChatDownloadBox> -->
                <ChatQuickReplyBox
                        v-if="(msg.type==='quick_reply' || msg.type==='rating')"
                        :isFirstMsg="msg.isFirstMsg"
                        :isLastMsg="msg.isLastMsg"
                        :content="msg.content"
                        :msgId="msg.id"
                        :msgReact="msg.react_icon"
                />
                <ChatCarouselBox
                        v-if="msg.type==='carousel'"
                        :content="msg.content"
                        :boxindex="msg.id"
                />
                <ChatUploadingBox
                        v-if="msg.type==='uploading'"
                        :file_name="msg.content.file_name"
                        :status="msg.content.status"
                />
                <ChatFileBox
                        v-if="msg.type==='file'"
                        :isFirstMsg="msg.isFirstMsg"
                        :isLastMsg="msg.isLastMsg"
                        :isUserSend="msg.source==='user'"
                        :content="msg.content"
                        :msgId="msg.id"
                        :msgReact="msg.react_icon"/>
                
            </div>
        </div>
        <ControlChat ref="control_chat"/>
        <CoolLightBox
                :items="lightBoxData"
                :index="lightBoxIndex"
                @close="hideLightBox()">
        </CoolLightBox>
    </div>
</template>

<script>
import ControlChat from './ControlChat'
import ChatTextBox from './ChatBoxElement/textBox'
import ChatImageBox from './ChatBoxElement/imageBox'
import ChatDownloadBox from './ChatBoxElement/downloadBox'
import ChatQuickReplyBox from './ChatBoxElement/quickReplyBox'
import ChatCarouselBox from './ChatBoxElement/carouselBox'
import ChatUploadingBox from './ChatBoxElement/uploadingBox'
import ChatFileBox from './ChatBoxElement/fileBox'
import $ from 'jquery'
import dataHandler from '../business/handler_data'
import messageHandler from '../business/handler_messages'
import { mapState } from 'vuex'

export default {
    name      : 'MainChatBox',
    components: {ControlChat, ChatTextBox, ChatImageBox, ChatQuickReplyBox, ChatCarouselBox, ChatDownloadBox, ChatUploadingBox, ChatFileBox},
    mounted() {

        this.$nextTick(() => {
            if (this.$store.state.scSubscribeChannel) {
                this.$store.state.scSubscribeChannel.watch(data => {
                    // console.log(data);
                    this.handler_messages(data)
                })
            }
            this.is_chat_with_bot()
            // load chat logs
            this.get_chat_logs()

            this.get_list_suggestion()            

        })

        this.$store.state.componentsMainChatBox = this

        $('.history-log-chat')[0].addEventListener('scroll', this.eventScrollChatlogs)
        // console.log('scrolling Injected');

    },
    beforeDestroy() {
        $('.history-log-chat')[0].removeEventListener('scroll', this.eventScrollChatlogs)
        // console.log('scrolling Destroyed');
    },
    data() {
        return {
            listMsg               : [],
            // for scroll to user's messenger
            usersMsgScrollTop     : 0,
            canLoadMoreChatLogs   : false,
            paramsLoadChatLogs    : '',
            displayLoadingChatlogs: false,
            // for scroll when load more msg
            scrollPosition        : 0
        }
    },
    computed  : {
        ...mapState(['lightBoxData', 'lightBoxIndex', 'styles'])
    },
    methods   : {
        hideLightBox() {
            this.$store.dispatch(this.$ActionTypes.SET_LIGHT_BOX_DATA_THEN_SHOW, {})
        },
        handler_messages(sc_msg) {
            // check is user send
            let msg          = {}
            // msg content
            msg.type         = sc_msg.type

            // Update 2021-08-09 - send event submit webview to socket if channel = livechat
            if (msg.type === 'user-submit-webview') {
                this.$store.state.componentsMainApp.close_webview();
                return;
            }

            // check if event admin assign request or mark done request -> change status suggest
            if (sc_msg.type === 'chatlog_system_notes') {
                if (sc_msg.chatlog_system_notes && sc_msg.chatlog_system_notes.length > 0) {
                    sc_msg.chatlog_system_notes.forEach(sm => {
                        if (sm.message_type === 'mark_request_support_as_done') {
                            this.$store.state.isChatWithBot = true
                        } else if (sm.message_type === 'assign_request_support') {
                            this.$store.state.isChatWithBot = false
                        }
                    })
                }
            }
            // check if event user request support & turn off bot -> change status suggest
            if (sc_msg.type === 'request_human_support' && sc_msg.content.disable_bot) {
                this.$store.state.isChatWithBot = false
            }

            msg.content      = sc_msg.content
            msg.created_time = sc_msg.created_time
            msg.react_icon   = sc_msg.react_icon ? sc_msg.react_icon : ''
            if (sc_msg['_id']) {
                msg.id = sc_msg['_id']
            } else {
                msg.id = dataHandler.guid()
            }

            let lengthMsg = this.listMsg.length
            if (sc_msg.source && sc_msg.source === 1) {
                msg.source = 'user'

                this.usersMsgScrollTop = $('.history-log-chat')[0].scrollHeight
                // } else if (sc_msg.source && sc_msg.source === "admin") {
            } else {
                msg.source = 'admin'

                this.usersMsgScrollTop = $('.history-log-chat')[0].scrollHeight
            }

            // check is first/last msg
            msg.isLastMsg = true
            if (lengthMsg > 0) {
                msg.isFirstMsg = msg.source !== this.listMsg[lengthMsg - 1].source
                if (msg.source === this.listMsg[lengthMsg - 1].source) {
                    this.listMsg[lengthMsg - 1].isLastMsg = false
                }
            } else {
                msg.isFirstMsg = true
            }

            // if history length > 0 and new message is not from user
            if (lengthMsg > 0 && msg.source !== 'user') {
                // check created time to push msg to right position
                for (let i = lengthMsg - 1; i >= 0; i--) {
                    // if last message is from user, stop check and push to list
                    if (this.listMsg[i].source === 'user') {
                        this.listMsg.splice(i + 1, 0, msg)
                        break
                    }
                    let new_msg_time = new Date(msg.created_time)
                    let compare_time = new Date(this.listMsg[i].created_time)
                    if (new_msg_time >= compare_time) {
                        this.listMsg.splice(i + 1, 0, msg)
                        break
                    } else if (i === 0) {
                        this.listMsg.splice(i, 0, msg)
                        break
                    }
                }
            } else {
                this.listMsg.push(msg)
            }

            this.$nextTick(() => {
                let el_logchat = $('.history-log-chat')[0]
                if (this.usersMsgScrollTop > 0) {
                    el_logchat.scrollTop = this.usersMsgScrollTop
                } else {
                    el_logchat.scrollTop = el_logchat.scrollHeight
                }

            })
        },

        async get_chat_logs() {
            // console.log(this.$store.state)
            let scroll_to_bt = !this.canLoadMoreChatLogs
            if (this.$store.state.clientId !== '') {
                let response_load_chatlogs  = await dataHandler.get_chat_logs(this.$store.state.clientId, this.$store.state.clientToken, this.$store.state.botCode, this.paramsLoadChatLogs)
                this.displayLoadingChatlogs = false
                // console.log(chatlogs)
                let chatlogs                = response_load_chatlogs.chatlog
                this.paramsLoadChatLogs     = response_load_chatlogs.next ? response_load_chatlogs.next : ''
                this.canLoadMoreChatLogs    = this.paramsLoadChatLogs !== ''

                if (chatlogs && chatlogs.length > 0) {
                    chatlogs.forEach(item => {
                        // console.log(item)
                        try {
                            let msg          = {}
                            // msg content
                            msg.type         = item.message_type
                            msg.content      = JSON.parse(item.message).content
                            msg.id           = item._id ? item._id : dataHandler.guid()
                            msg.created_time = item.created_time
                            msg.react_icon   = item.react_icon ? item.react_icon : ''

                            // check if type is quick reply -> hide all buttons
                            if (msg.type === 'quick_reply' || msg.type === 'rating') {
                                msg.content.buttons = []
                            }

                            // check sender
                            if (item.source === 1) {
                                msg.source = 'user'

                                // check payload - get_started
                                if (msg.type === 'payload' && msg.content.text !== 'get_started') {
                                    msg.type = 'text'
                                    if (msg.content.text.indexOf('#') >= 0) {
                                        msg.content.text = (msg.content.text.split('#').length === 3 ? msg.content.text.split('#')[2] : msg.content.text.split('#')[0])
                                    }

                                } else if (msg.type === 'payload' && msg.content.text === 'get_started') {
                                    return
                                }
                            }

                            // check is first/last msg
                            let lengthMsg  = this.listMsg.length
                            msg.isFirstMsg = true

                            if (lengthMsg > 0) {
                                msg.isLastMsg = msg.source !== this.listMsg[0].source
                                if (msg.source === this.listMsg[0].source) {
                                    this.listMsg[0].isFirstMsg = false
                                }
                            } else {
                                msg.isLastMsg = true
                            }

                            // console.log(msg);
                            this.listMsg.unshift(msg)

                        } catch (e) {
                            console.log(e)
                        }

                    })

                    // /* FOR TEST */
                    // let msgste = {
                    //   type: "upload_file",
                    //   content: {"url": "https://cdn-static-v3.fpt.ai/upload/7257d47bd9658ed5a953d42d7871b95c/dce2299f4c46122e937f676824402094.jpg"},
                    //   file_name: "2299.jpg",
                    //   id: dataHandler.guid(),
                    //   isFirstMsg: false,
                    //   isLastMsg: false,
                    //   source: 'user'
                    // }

                    // this.listMsg.push(msgste);
                    // /* END */

                    // console.log(this.listMsg)

                    this.$nextTick(() => {
                        let el_logchat = $('.history-log-chat')[0]
                        // console.log(el_logchat.style)
                        // .setAttribute('style', styleString);
                        // el_logchat.style.scrollBehavior = "auto"
                        el_logchat.setAttribute('style', 'scroll-behavior: auto;')
                        if (scroll_to_bt) {
                            el_logchat.scrollTop = el_logchat.scrollHeight
                        } else {
                            el_logchat.scrollTop = el_logchat.scrollHeight - this.scrollPosition - 22
                        }
                        // el_logchat.style.scrollBehavior = "smooth"
                        el_logchat.setAttribute('style', 'scroll-behavior: smooth;')
                    })
                } else {
                    // Update 2021-10-28: If chatlog = 0 & sender is custom, send start message
                    if (this.$store.state.customSender === true) {
                        this.process_send_start_message();
                    }
                }
            }

        },

        process_send_start_message() {
            if (this.$store.state.scSubscribeChannel) {
                messageHandler.send_start_message(this.$store.state.subChannel, this.$store.state.startPayload)
            } else {
                setTimeout(function() {
                    this.process_send_start_message();
                }.bind(this), 200)
            }
        },

        async eventScrollChatlogs(e) {
            // console.log(e)
            // TODO
            let objChatBox = $('.history-log-chat')[0]
            if (objChatBox.scrollTop === 0) {
                if (this.canLoadMoreChatLogs) {
                    this.scrollPosition         = objChatBox.scrollHeight
                    this.displayLoadingChatlogs = true
                    await this.get_chat_logs()
                }
            }
        },

        handler_message_uploading(msgId, status) {
            // status: 0: delete, 1: error
            for (let i = 0; i < this.listMsg.length; i++) {
                if (this.listMsg[i].id === msgId) {
                    if (status === 0) {
                        this.listMsg.splice(i, 1)
                    } else {
                        this.listMsg[i].content['status'] = 'failed'
                    }
                    break
                }
            }

        },

        async get_list_suggestion() {
            if (this.$store.state.clientId !== '') {
                let response_load_suggestion  = await dataHandler.get_suggestion_list(this.$store.state.clientId, this.$store.state.clientToken, this.$store.state.botCode)

                if (response_load_suggestion && response_load_suggestion.length > 0) {
                    // this.$store.state.suggestionList = response_load_suggestion;
                    this.$refs.control_chat.list_suggest = response_load_suggestion.map((s) => { return s.sample })
                }
            }
        },

        async is_chat_with_bot() {
            if (this.$store.state.clientId !== '') {
                let response_is_chat_with_bot  = await dataHandler.is_chat_with_bot(this.$store.state.clientId, this.$store.state.clientToken, this.$store.state.botCode)

                this.$store.state.isChatWithBot = response_is_chat_with_bot;
            }
        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .clearfix {
        position: relative;
    }
    .clearfix::after {display : block;content : "";clear : both;}
    .history-log-chat {background : transparent !important;}
</style>
